import { BreadcrumbSection } from "../../models/breadcrumb.model";

export function computeBreadcrumbClickable(
    breadcrumbSections: BreadcrumbSection[],
): BreadcrumbSection[] {
    return breadcrumbSections.map((breadcrumbSection, index, array) => ({
        ...breadcrumbSection,
        unclickable:
            breadcrumbSection.unclickable || index === array.length - 1,
    }));
}
